import * as React from "react";
import { Paper, Box, Typography } from "@mui/material";

/**
 * ScrollablePanel
 * - Fills 100% height of its parent
 * - Scrolls vertically only when content overflows
 * - Optional title bar
 */
export default function ScrollablePanel({ text, sx }) {

    const lines = text.split("\n");
    const displayedText = text;
    
    return (


            <Box
                sx={{
                    height:350,
                    flex: 1,
                    overflowY: "auto",
                    p: 0,
                    // tasteful scrollbar
                    "&::-webkit-scrollbar": { width: 8 }, 
                    "&::-webkit-scrollbar-thumb": {
                        borderRadius: 8,
                        backgroundColor: "rgba(0,0,0,0.25)",
                    },
                    "&::-webkit-scrollbar-track": { backgroundColor: "transparent" },
                }}
            >
                <Typography variant="body2" sx={{ whiteSpace: "pre-line" }}>
                    {displayedText}
                </Typography>
            </Box>

    );
}
